export async function execCopy({ selector }) {
  const text = document.querySelector(selector);

  await navigator.clipboard.writeText(text.value);

  window.getSelection().removeAllRanges();
}
